// extracted by mini-css-extract-plugin
export default {"pageView":"Page_pageView__nhn0C","contentWrapper":"Page_contentWrapper__FXen2","noData":"Page_noData__cnfOk"};